import { styled } from '@mui/system';
import { Box, Typography } from '@mui/material';

export const FeatureSettingsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  maxWidth: '50rem',
}));

export const FeatureSettingsHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

export const FeaturesList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  marginTop: theme.spacing(1),
}));

export const FeatureItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.secondary,
  borderRadius: '8px',
  gap: theme.spacing(2),
  transition: 'all 0.2s ease',
  '&:hover': {
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  },
}));

export const FeatureInfo = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
}));

export const FeatureTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const FeatureDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const FeatureControl = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexShrink: 0,
}));
